module.exports = __webpack_public_path__ + "static/media/right_arrow_go_btn.fb31b665.svg";